<!-- eslint-disable -->
<template>
  <div class="dash-page" id="dashboard">
    <div class="dash-bg">
      <div class="dash-gradient"></div>
      <div class="dash-pattern"></div>
    </div>

    <v-container id="panels" fluid tag="section">
      <v-row>
        <v-col class="mx-auto" cols="12" md="12">
          <base-material-tabs v-model="tab" color="warning" icons-and-text>
            <v-tab v-for="(t, i) in tabs" :key="i">
              {{ t.text }}
              <v-icon v-text="t.icon" />
            </v-tab>

            <v-tabs-items v-model="tab" class="pt-12 transparent">
              <!-- ================= TAB 1: ABSENSI ================= -->
              <v-tab-item>
                <!-- Hero / Info lokasi -->
                <v-card class="content-card pa-4 mb-4">
                  <v-alert border="top" colored-border type="warning" elevation="0" class="mb-0">
                    <div v-if="userAddress">
                      <strong>Alamat Kantor:</strong> <i>{{ officeAddress }}</i><br />
                      <strong>Lokasi Anda saat ini:</strong> <i>{{ userAddress }}</i><br />
                      <strong>Jarak dari Kantor:</strong> <i>{{ distanceText }}</i><br />
                      <strong>Status:</strong> <i><span v-html="locationStatus"></span></i><br />
                    </div>
                    <div v-else>
                      <span v-html="locationStatus"></span>
                    </div>
                  </v-alert>

                  <div v-if="error" class="mt-3" style="color: #b00020;">
                    {{ error }}
                  </div>
                </v-card>

                <v-container v-if="canAbsenOnline == 1" class="pa-0">
                  <v-row dense>
                    <!-- CHECK IN -->
                    <v-col cols="12" md="6" sm="6">
                      <v-card class="content-card bpdp-card-in" outlined>
                        <div class="bpdp-card-head bpdp-in-head">
                          <div class="bpdp-card-title">
                            <v-icon left>mdi-login</v-icon>
                            Check-IN
                          </div>
                          <div class="bpdp-card-subtitle">
                            Absen <b>Check-IN </b> aktif pada jam <b>06:00 - 09:00</b>
                            <!-- Absen Bln Ramadhan aktif: <b>06:00 - 09:00</b> <!--Bulan Ramadhan-->
                          </div>
                        </div>

                        <v-divider />

                        <v-card-text class="py-4">
                          <div class="d-flex align-center justify-space-between flex-wrap">
                            <div class="caption text--secondary">Waktu</div>
                            <div class="bpdp-time">
                              <span>{{ absenIn | formatDate }}</span>
                            </div>
                          </div>

                          <div class="mt-2">
                            <div class="caption text--secondary">Status Kerja</div>
                            <div class="subtitle-2">
                              <span v-if="extra.worksts == 'WFO'">{{ extra.worksts }}</span>
                              <span v-else-if="extra">{{ extra.worksts }} | {{ extra.worksts_ST }}</span>
                              <span v-else>-</span>
                            </div>
                          </div>

                          <div class="mt-2">
                            <div class="caption text--secondary">Koordinat</div>
                            <div class="caption">{{ locIn }}</div>
                          </div>
                        </v-card-text>

                        <v-card-actions class="px-4 pb-4">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div v-on="on" class="w-100" style="margin: 0 auto;">
                                <v-btn
                                  v-if="boolBtnIN"
                                  class="btn-primary"
                                  :disabled="isLoading"
                                  rounded
                                  block
                                  @click="dialogIN = true"
                                >
                                  <v-icon left>mdi-login</v-icon>
                                  Check-IN Disini
                                </v-btn>

                                <v-btn
                                  v-else-if="!boolBtnIN && absenIn"
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  <v-icon left>mdi-login</v-icon>
                                  Check-IN Berhasil
                                </v-btn>

                                <v-btn
                                  v-else
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  Check-IN Tidak Aktif
                                </v-btn>
                              </div>
                            </template>
                            <span v-if="boolBtnIN">Silakan Check-IN KLIK Disini.</span>
                            <span v-else>Tombol Check-IN tidak aktif.</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-col>

                    <!-- CHECK OUT -->
                    <v-col cols="12" md="6" sm="6">
                      <v-card class="content-card bpdp-card-out" outlined>
                        <div class="bpdp-card-head bpdp-out-head">
                          <div class="bpdp-card-title">
                            <v-icon left>mdi-logout</v-icon>
                            Check-OUT
                          </div>
                          <div class="bpdp-card-subtitle">
                            Absen <b>Check-OUT </b> aktif pada jam <b>15:31 - 23:59</b>-->
                            <!--Absen Bln Ramadhan aktif: <b>15:01 - 23:59</b> <!--Bulan Ramadhan-->
                          </div>
                        </div>

                        <v-divider />

                        <v-card-text class="py-4">
                          <div class="d-flex align-center justify-space-between flex-wrap">
                            <div class="caption text--secondary">Waktu</div>
                            <div class="bpdp-time">
                              <span>{{ absenOut | formatDate }}</span>
                            </div>
                          </div>

                          <div class="mt-2">
                            <div class="caption text--secondary">Status Kerja</div>
                            <div class="subtitle-2">
                              <span v-if="extra.worksts == 'WFO'">{{ extra.worksts }}</span>
                              <span v-else-if="extra">{{ extra.worksts }} | {{ extra.worksts_ST }}</span>
                              <span v-else>-</span>
                            </div>
                          </div>

                          <div class="mt-2">
                            <div class="caption text--secondary">Koordinat</div>
                            <div class="caption">{{ locOut }}</div>
                          </div>
                        </v-card-text>

                        <v-card-actions class="px-6 pb-6" >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div v-on="on" class="w-100" style="margin: 0 auto;">
                                <!-- normal -->
                                 
                                <v-btn
                                  v-if="diffMinute<=minuteKerja && absenOut=='-'"
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  <v-icon left>mdi-clock-alert-outline</v-icon>
                                  
                                  <span class="caption">Check-OUT Belum Aktif! {{jamAbsenOut | formatHour}}</span>
                                </v-btn>
                                
                                <v-btn
                                  v-else-if="svrHour < 15 && absenOut=='-'"
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  <v-icon left>mdi-clock-outline</v-icon>
                                  
                                  <span class="caption">Check-OUT Belum Aktif<br />Minimal jam pulang 15:31</span>
                                  <!--<span class="caption">Check-OUT Belum Aktif<br />Minimal jam pulang 15:01 (Ramadhan)</span>-->
                                </v-btn>

                                <v-btn
                                  v-else-if="boolBtnOUT && absenOut=='-'"
                                  class="btn-primary"
                                  :disabled="isLoading"
                                  rounded
                                  block
                                  @click="dialogOUT = true"
                                >
                                  <v-icon left>mdi-logout</v-icon>
                                  Check-OUT Disini
                                </v-btn>

                                <v-btn
                                  v-else-if="!boolBtnOUT && absenOut!='-' "
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  <v-icon left>mdi-logout</v-icon>
                                  Check-OUT Berhasil
                                </v-btn>

                                <v-btn
                                  v-else
                                  class="btn-secondary bpdp-disabled"
                                  rounded
                                  block
                                  disabled
                                >
                                  Check-OUT Tidak Aktif
                                </v-btn>
                              </div>
                            </template>

                            <span v-if="boolBtnOUT">Silakan Check-OUT KLIK Disini.</span>
                            <span v-else>Tombol Check-OUT tidak aktif.</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-else class="pa-0">
                  <v-card class="content-card pa-4">
                    <v-alert border="top" colored-border type="info" elevation="0" class="mb-0">
                      Absen Online sudah tidak diaktifkan dan kembali ke proses Absen NORMAL (Fingerprint) yang berada di Kantor BPDP.
                    </v-alert>
                  </v-card>
                </v-container>

                <v-card class="content-card pa-4 mt-4">
                  <v-alert border="top" colored-border type="info" elevation="0" class="mb-0">
                    <p class="display-1 mb-0" v-html="holidayInfo"></p>
                  </v-alert>
                </v-card>
              </v-tab-item>

              <!-- ================= TAB 2: DATA ABSEN (USER) ================= -->
              <v-tab-item>
                <base-material-card icon="mdi-clipboard-text" title="List Data Absen" class="px-5 py-3 content-shell">
                  <v-row align="center" class="py-2">
                    <v-col cols="12" sm="6" md="4">
                      <v-dialog
                        ref="SelMonth"
                        v-model="menuSelMonth"
                        :return-value.sync="selectedMonth"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="formattedMonth"
                            label="Pilih Bulan/Tahun"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          />
                        </template>

                        <v-date-picker v-model="selectedMonth" type="month" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menuSelMonth = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="saveMonth">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="3" md="2">
                      <v-btn class="btn-primary" block rounded :disabled="isLoading" @click="feedingTable()">
                        <v-icon left>mdi-refresh</v-icon>
                        Show Data
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="headers"
                    :items="listAbsens"
                    :items-per-page="15"
                    class="elevation-1 bpdp-table"
                    @selected="feedingTable()"
                  >
                    <template v-slot:item.ket="{ item }">
                      <div>Check-IN:</div>
                      <div>Check-OUT:</div>
                    </template>
                  </v-data-table>

                  <v-alert border="left" colored-border type="warning" elevation="2" class="mt-4">
                    <p class="subtitle-1 mb-2"><b>Keterangan:</b></p>
                    <div>H: Hadir</div>
                    <div>Xm : Tidak Absen / Check-IN Pagi</div>
                    <div>Xp : Tidak Absen / Check-OUT Sore</div>
                    <div>X : Tidak Absen</div>
                  </v-alert>
                </base-material-card>
              </v-tab-item>

              <!-- ================= TAB 3: REKAP ABSEN (ADMIN) ================= -->
              <v-tab-item>
                <base-material-card icon="mdi-clipboard-text" title="Rekap Data Absen Seluruh Pegawai" class="px-5 py-3 content-shell">
                  <v-row align="center" class="py-2">
                    <v-col cols="12" sm="5" md="4">
                      <v-dialog
                        ref="SelMonth"
                        v-model="menuSelMonth"
                        :return-value.sync="selectedMonth"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="selectedMonth"
                            label="Pilih Bulan/Tahun"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          />
                        </template>

                        <v-date-picker v-model="selectedMonth" type="month" scrollable>
                          <v-spacer />
                          <v-btn text color="primary" @click="menuSelMonth = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.SelMonth.save(selectedMonth)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="3" md="2">
                      <v-btn class="btn-primary" block rounded :disabled="isLoading" @click="feedingReportTable()">
                        <v-icon left>mdi-refresh</v-icon>
                        Show Data
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4" md="6" class="text-right">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="btn-secondary"
                            outlined
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            :disabled="listAbsensAllFileDW.length <= 0"
                          >
                            <export-excel
                              :data="listAbsensAllFileDW"
                              :name="excelfName"
                              type="xls"
                              :title="excelTitle"
                            >
                              Download Data
                              <v-icon right>mdi-download</v-icon>
                            </export-excel>
                          </v-btn>
                        </template>

                        <span v-if="listAbsensAllFileDW.length > 0">Silakan Download Excel KLIK Disini.</span>
                        <span v-else>Silakan Refresh Data Terlebih dahulu.</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="header_report"
                    :items="listAbsensAll"
                    :items-per-page="15"
                    class="elevation-1 bpdp-table"
                  />

                  <v-alert border="left" colored-border type="warning" elevation="2" class="mt-4">
                    <p class="subtitle-1 mb-2"><b>Keterangan:</b></p>
                    <div>H: Hadir</div>
                    <div>Xm : Tidak Absen / Check-IN Pagi</div>
                    <div>Xp : Tidak Absen / Check-OUT Sore</div>
                    <div>X : Tidak Absen</div>
                  </v-alert>
                </base-material-card>
              </v-tab-item>

              <!-- ================= TAB 4: REKAP JAM ABSEN (ADMIN) ================= -->
              <v-tab-item>
                <base-material-card icon="mdi-clipboard-text" title="List Data Absen dengan Waktu" class="px-5 py-3 content-shell">
                  <v-row align="center" class="py-2">
                    <v-col cols="12" sm="5" md="4">
                      <v-dialog
                        ref="SelMonth"
                        v-model="menuSelMonth"
                        :return-value.sync="selectedMonth"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="selectedMonth"
                            label="Pilih Bulan/Tahun"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          />
                        </template>

                        <v-date-picker v-model="selectedMonth" type="month" scrollable>
                          <v-spacer />
                          <v-btn text color="primary" @click="menuSelMonth = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.SelMonth.save(selectedMonth)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="3" md="2">
                      <v-btn class="btn-primary" block rounded :disabled="isLoading" @click="feedingReportWaktuTable()">
                        <v-icon left>mdi-refresh</v-icon>
                        Show Data
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4" md="6" class="text-right">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="btn-secondary"
                            outlined
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            :disabled="listAbsensAllFileDW2.length <= 0"
                          >
                            <export-excel
                              :data="listAbsensAllFileDW2"
                              :name="excelfName2"
                              type="xls"
                              :title="excelTitle"
                            >
                              Download Data
                              <v-icon right>mdi-download</v-icon>
                            </export-excel>
                          </v-btn>
                        </template>

                        <span v-if="listAbsensAllFileDW2.length > 0">Silakan Download Excel KLIK Disini.</span>
                        <span v-else>Silakan Refresh Data Terlebih dahulu.</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="header_report"
                    :items="listAbsensAll2"
                    :items-per-page="15"
                    class="elevation-1 bpdp-table"
                  />
                </base-material-card>
              </v-tab-item>
            </v-tabs-items>
          </base-material-tabs>
        </v-col>
      </v-row>

      <!-- Toast -->
      <v-snackbar v-model="toast.show" :timeout="toast.timeout">
        {{ toast.text }}
        <v-btn :color="toast.color" text @click="toast.show = false">Close</v-btn>
      </v-snackbar>

      <!-- Loading -->
      <v-dialog v-model="isLoading" fullscreen>
        <v-container fluid fill-height style="background-color: rgba(0, 0, 0, 0.8);">
          <v-layout justify-center align-center>
            <v-card width="70vW" class="pa-md-2 mx-lg-auto" outlined>
              <v-list-item three-line centered>
                <v-list-item-content>
                  <div class="overline mb-4">Processing</div>
                  <v-list-item-title class="headline mb-1">Please Wait....</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-layout>
        </v-container>
      </v-dialog>

      <!-- Dialog IN -->
      <v-dialog v-model="dialogIN" persistent max-width="70vW">
        <v-form ref="form" v-model="valid">
          <v-card class="content-card">
            <v-card-title class="headline">Absen Check-IN WFO/ WF(A/H)/ DINAS?</v-card-title>
            <v-card-text class="px-5 py-5">
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    :items="listStatus"
                    name="value"
                    label="Status Kerja"
                    v-model="extra.worksts"
                    item-text="text"
                    @change="checkStatus()"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6" v-if="['WFH', 'WFA', 'DINAS'].includes(extra.worksts)">
                  <v-text-field
                    v-model="extra.worksts_ST"
                    label="Surat Tugas WFH/ WFA/ DINAS"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" v-else-if="extra.worksts == 'WFO'">
                  <strong>Lokasi Anda saat ini:</strong> <i>{{ userAddress }}</i><br />
                  <strong>Jarak dari Kantor:</strong> <i>{{ distanceText }}</i><br />
                </v-col>

                <v-col cols="12" md="6" v-else>
                  <v-alert dense outlined type="warning">
                    Silakan pilih status Kerja anda saat ini dalam kondisi <b>WFO</b> atau <b>WFH/ WFA/ DINAS</b>.
                    Jika WFH/ WFA/ DINAS pastikan <b>Surat Tugas</b> sudah diberikan kepada <b>Divisi Umum dan SDM</b>.
                  </v-alert>
                </v-col>

                <v-col cols="12" md="12" class="amber lighten-4">
                  <strong>Status:</strong> <i><span v-html="locationStatus"></span></i><br />
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-secondary" outlined rounded @click="dialogIN = false">Batal</v-btn>

              <v-btn
                v-if="['WFH', 'WFA', 'DINAS'].includes(extra.worksts)"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkIN()"
              >
                Submit
              </v-btn>

              <v-btn
                v-else-if="extra.worksts == 'WFO' && isWithinRadius"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkIN()"
              >
                Submit
              </v-btn>

              <v-btn
                v-else-if="extra.worksts == 'WFO' && isWithinRadius2"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkIN()"
              >
                Submit
              </v-btn>

              <v-btn v-else class="btn-secondary bpdp-disabled" rounded disabled>
                Diluar Jangkauan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <!-- Dialog OUT -->
      <v-dialog v-model="dialogOUT" persistent max-width="70vW">
        <v-form ref="form" v-model="valid">
          <v-card class="content-card">
            <v-card-title class="headline">Absen Check-OUT WFO/ WF(A/H)/ DINAS?</v-card-title>
            <v-card-text>
              <br />
              <v-col cols="12" md="12" class="amber lighten-4">
                <strong>Jarak dari Kantor:</strong> <i>{{ distanceText }}</i><br />
                <strong>Status:</strong> <i><span v-html="locationStatus"></span></i><br />
              </v-col>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-secondary" outlined rounded @click="dialogOUT = false">Batal</v-btn>

              <v-btn
                v-if="['WFH', 'WFA', 'DINAS'].includes(extra.worksts)"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkOUT()"
              >
                Submit
              </v-btn>

              <v-btn
                v-else-if="isWithinRadius"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkOUT()"
              >
                Submit
              </v-btn>

              <v-btn
                v-else-if="isWithinRadius2"
                class="btn-primary"
                rounded
                :disabled="!valid"
                @click="checkOUT()"
              >
                Submit
              </v-btn>

              <v-btn v-else class="btn-secondary bpdp-disabled" rounded disabled>
                Diluar Jangkauan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
moment.locale();
import axios from "axios";

import { getSettingParam, getSettingParamAbsenVersioning } from "@/api/settingparam";
import {
  getAbsen,
  getListByMonthAllPegawai,
  insertAbsenOnline,
  updateAbsenOnline,
  getSvrtime,
  getHolidayByDate,
} from "@/api/absenonline";

export default {
  name: "DashboardPanels",

  data: () => ({
    gMapAPI: "AIzaSyBS5dDlEVKTL1U6GYKy5H6pKUIU2a6uqRE",
    isAdmin: false,
    tab: 0,
    toast: { show: false, color: "green", text: "", timeout: 2000 },
    tabs: [
      { text: "Absensi", icon: "mdi-information" },
      { text: "Data Absen", icon: "mdi-information" },
    ],
    absenIn: "-",
    locIn: "-",
    infoTL: "-",
    absenOut: "-",
    jamAbsenOut: "-",
    locOut: "-",
    infoPSW: "-",
    boolBtnIN: false,
    boolBtnOUT: false,
    dialogIN: false,
    dialogOUT: false,
    canAbsenOnline: 1,
    dataAbsen: null,
    dataUser: null,
    isLoading: false,
    menuSelMonth: false,
    headers: [
      { text: "ID", align: "start", sortable: true, value: "id" },
      { text: "NIK", value: "UserNIK", align: "center", class: "subtitle-1" },
      { text: "Tanggal", value: "tgl", align: "center", sortable: true, class: "subtitle-1" },
      { text: "Check-IN", value: "hdateIN", align: "center", class: "subtitle-1" },
      { text: "Check-OUT", value: "hdateOUT", align: "center", class: "subtitle-1" },
      { text: "Status", value: "stswfh", align: "center", class: "subtitle-1" },
      { text: "Kehadiran", value: "sts", align: "center", class: "subtitle-1" },
    ],
    header_report: [],
    listAbsens: [],
    listAbsensAll: [],
    listAbsensAllFileDW: [],
    listAbsensAll2: [],
    listAbsensAllFileDW2: [],
    listofDate: [],
    selectedMonth: new Date().toISOString().substr(0, 7),
    excelfName: "AbsenSipeg_" + moment().format("YYYYMM") + "_" + moment().format() + ".xls",
    excelfName2: "JamAbsenSipeg_" + moment().format("YYYYMM") + "_" + moment().format() + ".xls",
    excelTitle: "",
    diffMinute: 0,
    svrHour: 0,
    svrMinute: 0,
    minuteKerja: 570,
    address: null,
    geoip: null,
    listStatus: [
      { text: "WFH", value: "WFH" },
      { text: "WFO", value: "WFO" },
      { text: "WFA", value: "WFA" },
      { text: "DINAS", value: "DINAS" },
    ],
    extra: {
      worksts: "",
      worksts_ST: "",
    },
    valid: false,
    rules: {
      required: (v) => !!v || "Required.",
    },
    servertime: null,
    vrefresh: null,
    vrefreshAbsen: null,
    vrefreshSipeg: null,
    holidayInfo: "",
    todayisHoliday: false,

    /** add fitur jarak */
    userLocation: null,
    officeAddress: "Gd. Surachman Tjokroadisurjo & Smesco Indonesia",
    userAddress: "",
    arruserAdress: [],
    targetLocation: { lat: -6.1792037, lng: 106.8330286 }, // KKP
    targetLocation2: { lat: -6.2417928, lng: 106.8361639 }, // SMESCO
    radius: 250,
    radius2: 250,
    distance: 0,
    isWithinRadius: false,
    distance2: 0,
    isWithinRadius2: false,
    locationStatus: "Mendeteksi lokasi Anda...",
    error: null,
    geocoder: null,

    /**check fake GPS */
    positionAccuracy: null,
    positionTimestamp: null,
    isUsingFakeGps: false,
    checks: {
      accuracyTooPerfect: false,
      speedMismatch: false,
      altitudeMismatch: false,
      mockIndicator: false,
    },
  }),

  filters: {
    formatDate: function (value) {
      if (!value || value === "-") return "NA";
      var sdate = moment(value).format("DD MMM YYYY HH:mm");
      return sdate;
    },
    formatHour: function (value) {
      if (!value || value === "-") return "NA";
      var sdate = moment(value).format("HH:mm");
      return sdate;
    },
  },

  computed: {
    computedValue: function () {
      return this.servertime;
    },
    formattedMonth() {
      if (!this.selectedMonth) return "";
      const [year, month] = this.selectedMonth.split("-");
      return new Date(year, month - 1).toLocaleString("id-ID", {
        month: "long",
        year: "numeric",
      });
    },
    distanceText() {
      if (this.distance < 1000) {
        return `${Math.round(this.distance)} meter`;
      } else if (this.distance2 < 1000) {
        return `${Math.round(this.distance2)} meter`;
      } else {
        return `${(this.distance / 1000).toFixed(2)} kilometer dari Gd. Surachman / ${(this.distance2 / 1000).toFixed(
          2
        )} kilometer dari Smesco`;
      }
    },
    formattedLocationStatus() {
      if (this.isWithinRadius || this.isWithinRadius2) {
        return `Anda berada dalam radius ${this.radius}m dari lokasi target.`;
      } else {
        return `Anda berada di luar radius ${this.radius}m dari lokasi target.`;
      }
    },
  },

  created() {
    const vm = this;
    let sUser = localStorage.getItem("user");
    vm.dataUser = JSON.parse(sUser);
    vm.isAdmin = false;

    if (vm.dataUser !== null) {
      if (vm.dataUser.role !== null) {
        if (vm.dataUser.role.id === 1) {
          vm.isAdmin = true;
        }
      }
    }

    vm.checkSetting();

    if (vm.isAdmin) {
      vm.tabs = [
        { text: "Absensi", icon: "mdi-information" },
        { text: "Data Absen", icon: "mdi-information" },
        { text: "Rekap Absen Seluruh Pegawai", icon: "mdi-information" },
        { text: "Rekap JAM Absen Seluruh Pegawai", icon: "mdi-clock" },
      ];
      vm.prepareReports();
    }

    vm.vrefresh = setInterval(function () {
      vm.getServerTime()
    }, 5*60*1000);

    vm.vrefreshAbsen = setInterval(function () {
      vm.getdataAbsen()
    }, 15*60*1000);

    vm.vrefreshSipeg = setInterval(function () {
      vm.refreshBrowser()
    }, 60*60*1000);

    vm.getServerTime();
  },

  destroyed() {
    clearInterval(this.vrefresh);
    clearInterval(this.vrefreshAbsen);
    clearInterval(this.vrefreshSipeg);
  },

  mounted() {
    const vm = this;

    vm.getGeoIP();

    if (window.google) {
      vm.initGeocoder();
      vm.getUserLocation();
    } else {
      vm.loadGoogleMaps();
    }

    vm.checkSettingVersioning();
    
    
  },

  methods: {
    saveMonth() {
      this.$refs.SelMonth.save(this.selectedMonth);
      this.menuSelMonth = false;
    },

    loadGoogleMaps() {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=` + this.gMapAPI + `&libraries=geometry,places`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => {
        this.initGeocoder();
        this.getUserLocation();
      };

      script.onerror = () => {
        this.error = "Gagal memuat Google Maps API";
        this.locationStatus = "Gagal memuat Google Maps API";
      };
    },

    initGeocoder() {
      this.geocoder = new google.maps.Geocoder();
    },

    getServerTime(){
      const vm = this;

      getSvrtime()
      .then((response) => {
        var svrtime = response.data;

        vm.servertime = moment(svrtime);
        var today = moment(vm.servertime).format("YYYY-MM-DD");
        vm.svrHour = moment(vm.servertime).format("H");
        vm.svrMinute = moment(vm.servertime).format("m");
        
        vm.counterTimer();

        vm.holidayInfo = "";
        vm.todayisHoliday = false;

        vm.getdataAbsen();

        getHolidayByDate(today)
          .then((response) => {
            var dholidays = response.data;

            if (dholidays) {
              var head = "<ul>";
              var child = "";

              function removeDuplicates(data) {
                var arr = [];
                return data.filter(function (x) {
                  return !contains(arr, x) && arr.push(x);
                });
              }
              function contains(array, obj) {
                for (var i = 0; i < array.length; i++) {
                  if (isEqual(array[i], obj)) return true;
                }
                return false;
              }
              function isEqual(obj1, obj2) {
                if (obj1.name == obj2.name) return true;
                return false;
              }

              var filtered = removeDuplicates(dholidays);

              filtered.forEach((el) => {
                if (el.type[0] == "National holiday") {
                  var strdate = moment(el.date["iso"], "YYYY-MM-DD").format("LL");
                  child = child + "<li>";
                  if (el.date["iso"] === today) {
                    vm.todayisHoliday = true;
                    var strname = el.name;
                    child = child + '<span class="display-2">' + strdate + ": " + strname + "</span>";
                  } else {
                    child = child + strdate + ": " + el.name;
                  }

                  child = child + '<br><span class="caption font-italic font-weight-light">' + el.description + "</span>";
                  child = child + "</li>";
                }
              });
              vm.holidayInfo = head + child + "</ul>";
            }
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => {
        vm.servertime = null;
        console.log(err);
      });
    },

    
    counterTimer() {
      // 🔹 Timer berjalan tiap detik
      const vm = this;

      if(vm.servertime){
        setInterval(() => {
          if (vm.servertime) {
            vm.timeChecker();
            vm.servertime.add(1, "second"); // tambah 1 detik
            console.log("Current Time:", vm.servertime.format("YYYY-MM-DD HH:mm:ss"));
          }
        }, 1000);
      }else{
        console.log("SVRTIME NULL")
      }
      
    },

    getUserLocation() {
      this.locationStatus = "Mendeteksi lokasi...";
      this.isUsingFakeGps = false;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            this.getAddressName();

            this.positionAccuracy = position.coords.accuracy;
            this.positionTimestamp = new Date(position.timestamp).toLocaleString();

            this.checkForFakeGps(position);
            this.locationStatus = this.checkDistance();
          },
          (error) => {
            this.handleLocationError(error);
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } else {
        this.error = "Geolocation tidak didukung oleh browser Anda.";
        this.locationStatus = "Geolocation tidak didukung oleh browser Anda";
      }
    },

    checkForFakeGps(position) {
      this.checks = {
        accuracyTooPerfect: false,
        speedMismatch: false,
        altitudeMismatch: false,
        mockIndicator: false,
      };

      this.checks.accuracyTooPerfect = position.coords.accuracy === 0;

      if (position.coords.speed !== null) {
        this.checks.speedMismatch = position.coords.speed > 50;
      }

      if (position.coords.altitude !== null) {
        this.checks.altitudeMismatch = position.coords.altitude > 10000 || position.coords.altitude < -100;
      }

      this.checks.mockIndicator = position.coords.mock === true || position.mock === true || position.coords.altitude === 0;

      const positiveChecks = Object.values(this.checks).filter(Boolean).length;
      this.isUsingFakeGps = positiveChecks >= 2;

      if (this.isUsingFakeGps) {
        this.locationStatus = "Lokasi berhasil dideteksi (kemungkinan fake GPS)";
      } else {
        this.locationStatus = "Lokasi berhasil dideteksi";
      }
    },

    checkDistance() {
      if (!this.userLocation || !window.google) return;

      this.distance = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(this.userLocation.lat, this.userLocation.lng),
        new google.maps.LatLng(this.targetLocation.lat, this.targetLocation.lng)
      );
      this.distance2 = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(this.userLocation.lat, this.userLocation.lng),
        new google.maps.LatLng(this.targetLocation2.lat, this.targetLocation2.lng)
      );

      this.isWithinRadius = this.distance <= this.radius;
      this.isWithinRadius2 = this.distance2 <= this.radius2;

      if (this.isWithinRadius || this.isWithinRadius2) {
        return `Anda berada <span style="color: green;">DALAM</span> radius ${this.radius}m dari lokasi Kantor.`;
      } else {
        return `Anda berada di <span style="color: red;">LUAR</span> radius ${this.radius}m dari lokasi Kantor.`;
      }
    },

    getAddressName() {
      if (!this.geocoder || !this.userLocation) return;

      this.geocoder.geocode({ location: this.userLocation }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.userAddress = results[0].formatted_address;
            // NOTE: index ini tergantung struktur results; dibiarkan seperti versi kamu
            try {
              this.arruserAdress = [
                results[0].address_components[5].long_name,
                results[0].address_components[6].long_name,
                results[0].address_components[7].long_name,
              ];
            } catch (e) {
              this.arruserAdress = [];
            }
          } else {
            this.userAddress = "Alamat tidak ditemukan";
          }
        } else {
          this.userAddress = "Tidak dapat mendapatkan alamat";
          console.error("Geocoder error:", status);
        }
      });
    },

    handleLocationError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.error = "Pengguna menolak permintaan geolokasi.";
          break;
        case error.POSITION_UNAVAILABLE:
          this.error = "Informasi lokasi tidak tersedia.";
          break;
        case error.TIMEOUT:
          this.error = "Permintaan untuk mendapatkan lokasi pengguna habis waktunya.";
          break;
        case error.UNKNOWN_ERROR:
          this.error = "Terjadi kesalahan yang tidak diketahui.";
          break;
      }
    },

    checkSetting() {
      const vm = this;
      vm.isLoading = true;
      vm.canAbsenOnline = 1;
      getSettingParam()
        .then((response) => {
          var array = response.data;
          vm.canAbsenOnline = 0;

          if (array !== null) {
            if (array.length > 0) {
              array.forEach((element) => {
                if (element.Deskripsi === "isAbsenOnline") {
                  vm.canAbsenOnline = element.value;
                }
              });
            }
          }
          vm.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          vm.canAbsenOnline = 1;
          vm.isLoading = false;
        });
    },

    checkSettingVersioning() {
      const vm = this;
      vm.isLoading = true;
      var currVersion = localStorage.getItem("currVersion") ? localStorage.getItem("currVersion") : 0;

      getSettingParamAbsenVersioning()
        .then((response) => {
          var array = response.data;

          if (array !== null) {
            if (array.length > 0) {
              array.forEach((element) => {
                if (element.Deskripsi === "absenVersioning") {
                  if (currVersion == element.value) {
                    console.log("==> sipeg param v.", element.value);
                  } else {
                    console.log("==> version value settingparam not match ==>relogin");
                    this.$store.commit("CLEAR_USER");
                    localStorage.removeItem("user");
                    localStorage.removeItem("jwt");
                    window.location = "/";
                  }
                }
              });
            }
          }
          vm.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          vm.canAbsenOnline = 1;
          vm.isLoading = false;
        });
    },

    checkStatus() {
      console.log("checkStatus", this.extra.worksts);
    },

    feedingTable() {
      const vm = this;
      var user = vm.dataUser;
      var month = moment(vm.selectedMonth).format("YYYY-MM");
      vm.isLoading = true;
      getAbsen(user.nik, month)
        .then((response) => {
          var data = response.data;
          var result = [];
          if (data.length > 0) {
            data.forEach((element) => {
              element["sts"] = "H";
              if (moment(element.dateIN).isValid()) {
                element["tgl"] = moment(element.dateIN).format("DD MMM YYYY");
                element["hdateIN"] = moment(element.dateIN).format("HH:mm:ss");
              } else {
                element["hdateIN"] = "-";
                element["sts"] = "Xm";
              }

              element["stswfh"] = "-";
              if (element.workstatus) {
                if (element.workstatus_ST) {
                  element["stswfh"] = element.workstatus + " (" + element.workstatus_ST + ")";
                } else {
                  element["stswfh"] = element.workstatus;
                }
              }

              if (moment(element.dateOUT).isValid()) {
                element["tgl"] = moment(element.dateOUT).format("DD MMM YYYY");
                element["hdateOUT"] = moment(element.dateOUT).format("HH:mm:ss");
              } else {
                element["hdateOUT"] = "-";
                if (!moment().isSame(element.dateIN, "day")) {
                  element["sts"] = "Xp";
                } else {
                  element["sts"] = "-";
                }
              }

              var isXmdouble = false;
              if (element["sts"] === "Xm") {
                var obj = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj) {
                  obj.forEach((el) => {
                    if (moment(el.dateIN).isValid()) {
                      element["tgl"] = moment(el.dateIN).format("DD MMM YYYY");
                      element["hdateIN"] = moment(el.dateIN).format("HH:mm:ss");
                      element["sts"] = "Xp";
                      isXmdouble = true;
                    }
                  });
                }
              }

              var isXpdouble = false;
              if (element["sts"] === "Xp") {
                var obj2 = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj2) {
                  obj2.forEach((el) => {
                    if (moment(el.dateOUT).isValid()) {
                      element["tgl"] = moment(el.dateOUT).format("DD MMM YYYY");
                      element["hdateOUT"] = moment(el.dateOUT).format("HH:mm:ss");
                      element["sts"] = "H";
                      isXpdouble = true;
                    }
                  });
                }
              }

              if (!moment(element.dateIN).isValid() && !moment(element.dateOUT).isValid()) {
                element["tgl"] = "-";
                element["hdateIN"] = "-";
                element["hdateOUT"] = "-";
                element["sts"] = "X";
              }

              if (isXmdouble || isXpdouble) {
                console.log("double data: ", element["tgl"]);
              } else {
                result.push(element);
              }
            });
          }

          let sorted = result.sort((a, b) => {
            const adate = moment(a.tgl, "DD MMM YYYY");
            const bdate = moment(b.tgl, "DD MMM YYYY");
            if (!a || !b || !a.tgl || !b.tgl) return 0;
            else return bdate - adate;
          });

          vm.listAbsens = sorted;
          vm.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          vm.isLoading = false;
        });
    },

    getGeoIP() {
      const vm = this;
      axios
        .get("https://api.ipify.org?format=json")
        .then((response) => {
          if (!response) throw Error("No geoIP found.");
          if (response.data) {
            vm.geoip = response.data.ip;
            console.log("geoip", vm.geoip);
          }
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
    refreshBrowser(){
      console.log("refresh");
      window.location = "/#/wfh/absen";
    },
    getdataAbsen() {
      const vm = this;
      var user = vm.dataUser;
      var today = moment(vm.servertime).format("YYYY-MM-DD");

      getAbsen(user.nik, today, vm.extra.worksts)
        .then((response) => {
          var data = response.data;
          if (data.length > 0) {
            vm.dataAbsen = data[0];
            vm.extra.worksts = vm.dataAbsen.workstatus;
            if (!vm.extra.worksts) vm.extra.worksts = "WFH";
            vm.extra.worksts_ST = vm.dataAbsen.workstatus_ST;
          }
          this.refresh();
        })
        .catch((err) => console.log(err));
    },

    timeChecker() {
       // TESTING
        
        //this.boolBtnIN = true
        //this.boolBtnOUT = true
        //this.diffMinute = 570
        //return true
        
        // DISABLED: adopsi lembur sabtu minggu dibuka untuk absen sipeg
        /*
        if (moment().day() === 0 || moment().day() === 6 ||this.todayisHoliday) {
          this.boolBtnIN = false
          this.boolBtnOUT = false
          // console.log('today is not office day..')
          return true
        }
        */

        this.minuteKerja = 570 
        //this.minuteKerja = 480 /* Ramadhan Month -> disabled if not ramadhan*/
        
        var svrtime = this.servertime
        //TESTING
        //var sample = '2026-03-12 17:35:00'
        //svrtime = moment(new Date(sample))
        //console.log('sample svrtime: ', moment(new Date(sample)).format('YYYY-MM-DD HH:mm:ss'))
        //=======
    

        const now = moment()
        // console.log('daysame: ', svrtime.isSame(now, 'day'))
        if (!svrtime.isSame(now, 'day')) {
          console.log('today not same with server day!!')
          return false
        }

        this.svrHour = moment(this.servertime).format('H')
        this.svrMinute = moment(this.servertime).format("m");
        //TESTING
        //this.svrHour = moment(svrtime).format('H')
        //=======
        // console.log("SVR H:M ", this.svrHour, this.svrMinute)

        const ndate = moment(svrtime).format('YYYY-MM-DD')
        //Normal
        var inbeforeTime = moment(ndate + ' 06:00:00').format('YYYY-MM-DD HH:mm:ss') //05
        var inafterTime = moment(ndate + ' 09:00:00').format('YYYY-MM-DD HH:mm:ss') //09
        var outbeforeTime = moment(ndate + ' 15:30:00').format('YYYY-MM-DD HH:mm:ss') //15
        var outafterTime = moment(ndate + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss') //23

        //Ramadhan -> disabled if not ramadhan
        //inbeforeTime = moment(ndate + ' 06:00:00').format('YYYY-MM-DD HH:mm:ss') //06
        //inafterTime = moment(ndate + ' 09:00:00').format('YYYY-MM-DD HH:mm:ss')
        //outbeforeTime = moment(ndate + ' 15:00:00').format('YYYY-MM-DD HH:mm:ss')
        //--- -> end

        var absenIn = this.absenIn
        //TESTING
        //var sample = '2026-03-12 06:05:00' //'' // '2023-03-26 07:33:00'
        //absenIn = moment(new Date(sample)).format('YYYY-MM-DD HH:mm:ss')
        //======
        // console.log("--1 absenIn",absenIn)
        
        if (moment(new Date(absenIn)).isValid()) {
          this.boolBtnIN = false
        }
        else {
          // console.log("--1 inbeforeTime",inbeforeTime)
          // console.log("--1 inafterTime",inafterTime)
          if (svrtime.isBetween(inbeforeTime, inafterTime)) {
            this.boolBtnIN = true
          }
          else {
            this.boolBtnIN = false
          }
        }
        var absenOut = this.absenOut
        //console.log("--2 absenOut",absenOut)
        var vmabsenin = moment().format('YYYY-MM-DD 07:30:00') // jika lupa absen pagi
        //console.log("--2 vmabsenin",vmabsenin)

        var abseninc = absenIn
        if (!moment(new Date(absenIn)).isValid()) {
          abseninc = vmabsenin
        }
        // console.log("--2 abseninc", moment(new Date(abseninc)).format('YYYY-MM-DD HH:mm:ss'))

        if (moment(new Date(absenOut)).isValid()) {
          this.boolBtnOUT = false
          this.boolBtnIN = false
        }
        else {
          // console.log("--2 outbeforeTime",outbeforeTime)
          // console.log("--2 outafterTime",outafterTime)
          if (svrtime.isBetween(outbeforeTime, outafterTime)) {

            var a = moment(new Date(abseninc))
            var b = moment(svrtime, "HH:mm:ss")
            this.diffMinute = b.diff(a, 'minutes')

            if(moment(new Date(abseninc)).format('H') < 7){
              var a = moment(new Date(abseninc)).add(0, 'minutes')
              this.diffMinute = b.diff(a, 'minutes')
            }

            var b_H = moment(svrtime).format("H")
            var b_M = moment(svrtime).format("m")
            console.log("--3 bM",b_H,b_M)
            if(b_H >= 15 && b_M >= 1 && moment(new Date(abseninc)).format('H') < 7){
              this.boolBtnOUT = true
            } else if(this.diffMinute > this.minuteKerja){
              this.boolBtnOUT = true
            }else{
              this.boolBtnOUT = false
            }
            
          }else {
            this.boolBtnOUT = false
          }
        }
        // console.log(this.diffMinute+ "==" + this.minuteKerja)
        // console.log("--3 btnOUT",this.boolBtnOUT)

        if(moment(new Date(abseninc)).format('H') < 7){
          this.jamAbsenOut = moment(new Date(abseninc)).add(this.minuteKerja+1, 'minutes') // Normal
          //this.jamAbsenOut = moment().format('YYYY-MM-DD 15:01:00') // Ramadhan, disabled if not ramadhan

        }else{
          this.jamAbsenOut = moment(new Date(abseninc)).add(this.minuteKerja+1, 'minutes')
        }
        var c = moment(new Date(this.jamAbsenOut)).format("HH:mm")
        // console.log("--3 jamAbsenOut", c)

    },

    refresh() {
      var dabsen = this.dataAbsen;
      if (dabsen !== null) {
        if (dabsen.dateIN !== null) {
          this.absenIn = moment(dabsen.dateIN, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("YYYY-MM-DD HH:mm:ss");
          this.absenIn = moment(this.absenIn).toDate().getTime();
          this.locIn = "" + dabsen.INLong + " | " + dabsen.INLat;
        }
        if (dabsen.dateOUT !== null) {
          this.absenOut = moment(dabsen.dateOUT, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("YYYY-MM-DD HH:mm:ss");
          this.absenOut = moment(this.absenOut).toDate().getTime();
          this.locOut = "" + dabsen.OUTLong + " | " + dabsen.OUTLat;
        }
      }
      this.timeChecker();
    },

    checkIN() {
      const vm = this;
      vm.dialogIN = false;

      var usr = vm.dataUser;
      var now = moment().add(7, "hours").format("YYYY-MM-DD HH:mm:ss");
      var long = "";
      var lat = "";

      if (vm.userLocation !== null) {
        long = vm.userLocation.lng;
        lat = vm.userLocation.lat;
      }

      if (long == "" || long == null || lat == "" || lat == null) {
        vm.toast = { show: true, color: "red", text: "Posisi Longitude dan Latitude NULL", timeout: 2000 };
        return false;
      }

      var today = moment(vm.servertime).format("YYYY-MM-DD");

      getAbsen(usr.nik, today, vm.extra.worksts)
        .then((response) => {
          var data = response.data;

          if (data.length > 0) {
            vm.dataAbsen = data[0];

            vm.extra.worksts = vm.dataAbsen.workstatus;
            if (!vm.extra.worksts) vm.extra.worksts = "WFH";
            vm.extra.worksts_ST = vm.dataAbsen.workstatus_ST;

            if (vm.dataAbsen !== null) {
              if (vm.dataAbsen.dateIN == null) {
                var updData = {
                  user: usr.id,
                  UserNIK: usr.nik,
                  dateIN: now,
                  OUTLong: long.toString(),
                  OUTLat: lat.toString(),
                  status: "in",
                  workstatus: vm.extra.worksts,
                  workstatus_ST: vm.extra.worksts_ST,
                };
                var idb = vm.dataAbsen.id;

                vm.isLoading = true;
                updateAbsenOnline("in", updData, idb, vm.extra.worksts)
                  .then((response) => {
                    vm.dataAbsen = response.data;
                    vm.isLoading = false;
                    vm.refresh();
                    vm.toast = { show: true, color: "primary", text: "Absen Check-IN telah BERHASIL.", timeout: 2000 };
                  })
                  .catch((err) => {
                    console.log(err);
                    vm.isLoading = false;
                    vm.toast = {
                      show: true,
                      color: "red",
                      text: "Absen Check-IN GAGAL, silakan lakukan Refresh Browser atau Logout dan Login ulang kembali.",
                      timeout: 2000,
                    };
                  });
              } else {
                vm.refresh();
                vm.toast = { show: true, color: "primary", text: "Anda telah Absen Check-IN.", timeout: 2000 };
              }
            }
          } else {
            var insData = {
              user: usr.id,
              UserNIK: usr.nik,
              dateIN: now,
              INLong: long.toString(),
              INLat: lat.toString(),
              status: "in",
              workstatus: vm.extra.worksts,
              workstatus_ST: vm.extra.worksts_ST,
              INLocStatus: JSON.stringify(vm.arruserAdress),
              INdistanceText: vm.distanceText,
            };

            vm.isLoading = true;
            insertAbsenOnline("in", insData, vm.extra.worksts)
              .then((response) => {
                vm.dataAbsen = response.data;
                vm.isLoading = false;
                vm.refresh();
                vm.toast = { show: true, color: "green", text: "Absen Check-IN telah BERHASIL.", timeout: 2000 };
              })
              .catch((err) => {
                console.log(err);
                vm.isLoading = false;
                vm.toast = {
                  show: true,
                  color: "red",
                  text: "Absen Check-IN GAGAL, silakan lakukan Refresh Browser atau Logout dan Login ulang kembali.",
                  timeout: 2000,
                };
              });
          }
        })
        .catch((err) => console.log(err));
    },

    checkOUT() {
      const vm = this;
      vm.dialogOUT = false;

      var usr = vm.dataUser;
      var now = moment().add(7, "hours").format("YYYY-MM-DD HH:mm:ss");
      var long = "";
      var lat = "";

      if (vm.userLocation !== null) {
        long = vm.userLocation.lng;
        lat = vm.userLocation.lat;
      }

      if (long == "" || long == null || lat == "" || lat == null) {
        vm.toast = { show: true, color: "red", text: "Posisi Longitude dan Latitude NULL", timeout: 2000 };
        return false;
      }

      var today = moment(vm.servertime).format("YYYY-MM-DD");

      getAbsen(usr.nik, today, vm.extra.worksts)
        .then((response) => {
          var data = response.data;

          if (data.length > 0) {
            vm.dataAbsen = data[0];

            vm.extra.worksts = vm.dataAbsen.workstatus;
            if (!vm.extra.worksts) vm.extra.worksts = "WFH";
            vm.extra.worksts_ST = vm.dataAbsen.workstatus_ST;

            if (vm.dataAbsen !== null) {
              if (vm.dataAbsen.dateOUT == null) {
                var updData = {
                  user: usr.id,
                  UserNIK: usr.nik,
                  dateOUT: now,
                  OUTLong: long.toString(),
                  OUTLat: lat.toString(),
                  status: "out",
                  updated_at: now,
                  OUTLocStatus: JSON.stringify(vm.arruserAdress),
                  OUTdistanceText: vm.distanceText,
                };
                var idb = vm.dataAbsen.id;

                vm.isLoading = true;
                updateAbsenOnline("out", updData, idb, vm.extra.worksts)
                  .then((response) => {
                    vm.dataAbsen = response.data;
                    vm.isLoading = false;
                    vm.refresh();
                    vm.toast = { show: true, color: "primary", text: "Absen Check-OUT telah BERHASIL.", timeout: 2000 };
                  })
                  .catch((err) => {
                    console.log(err);
                    vm.isLoading = false;
                    vm.toast = {
                      show: true,
                      color: "red",
                      text: "Absen Check-OUT GAGAL, silakan lakukan Refresh Browser atau Logout dan Login ulang kembali.",
                      timeout: 2000,
                    };
                  });
              } else {
                vm.refresh();
                vm.toast = { show: true, color: "primary", text: "Anda telah Absen Check-OUT.", timeout: 2000 };
              }
            }
          } else {
            var insData = {
              user: usr.id,
              UserNIK: usr.nik,
              dateOUT: now,
              OUTLong: long.toString(),
              OUTLat: lat.toString(),
              status: "out",
            };

            vm.isLoading = true;
            insertAbsenOnline("out", insData, vm.extra.worksts)
              .then((response) => {
                vm.dataAbsen = response.data;
                vm.isLoading = false;
                vm.refresh();
                vm.toast = { show: true, color: "green", text: "Absen Check-OUT telah BERHASIL.", timeout: 2000 };
              })
              .catch((err) => {
                console.log(err);
                vm.isLoading = false;
                vm.toast = {
                  show: true,
                  color: "red",
                  text: "Absen Check-OUT GAGAL, silakan lakukan Refresh Browser atau Logout dan Login ulang kembali.",
                  timeout: 2000,
                };
              });
          }
        })
        .catch((err) => console.log(err));
    },

    prepareReports() {
      const vm = this;
      vm.header_report = [
        { text: "NIK", value: "UserNIK", align: "center", sortable: true, class: "subtitle-1" },
        { text: "Nama", value: "fullname", align: "center", sortable: true, class: "subtitle-1" },
      ];

      function getAllDatesOfMonth() {
        var ar = [];
        var start = moment(vm.selectedMonth, "YYYY-MM");
        for (var end = moment(start).add(1, "month"); start.isBefore(end); start.add(1, "day")) {
          if (moment(start).day() !== 0 && moment(start).day() !== 6) {
            ar.push(start.format("YYYY-MM-DD"));
          }
        }
        return ar;
      }
      vm.listofDate = getAllDatesOfMonth();

      vm.listofDate.forEach((element) => {
        var temp = { text: element, value: element, align: "center", class: "subtitle-1" };
        vm.header_report.push(temp);
      });
    },

    feedingReportTable() {
      const vm = this;
      var month = moment(vm.selectedMonth).format("YYYY-MM");
      var smonth = moment(vm.selectedMonth).format("MMM YYYY");
      vm.excelTitle = "DATA ABSENSI SIPEG " + smonth;
      vm.prepareReports();

      vm.listAbsensAllFileDW = [];
      vm.listAbsensAll = [];
      vm.isLoading = true;

      getListByMonthAllPegawai(month)
        .then((response) => {
          var data = response.data;
          var tmpData = [];

          if (data.length > 0) {
            data.forEach((element) => {
              element["sts"] = "H";
              if (moment(element.dateIN).isValid()) {
                element["tgl"] = moment(element.dateIN).format("YYYY-MM-DD");
              } else {
                element["sts"] = "Xm";
              }

              if (moment(element.dateOUT).isValid()) {
                element["tgl"] = moment(element.dateOUT).format("YYYY-MM-DD");
              } else {
                if (!moment().isSame(element.dateIN, "day")) element["sts"] = "Xp";
                else element["sts"] = "-";
              }

              if (element["sts"] === "Xm") {
                var obj = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj) {
                  obj.forEach((el) => {
                    if (moment(el.dateIN).isValid()) element["sts"] = "Xp";
                  });
                }
              }
              if (element["sts"] === "Xp") {
                var obj2 = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj2) {
                  obj2.forEach((el) => {
                    if (moment(el.dateOUT).isValid()) element["sts"] = "H";
                  });
                }
              }

              var strsts = element["sts"];
              element["stsdw"] = strsts;
              element["stswfh"] = "-";
              if (element.workstatus) {
                if (element.workstatus_ST) element["stswfh"] = element.workstatus + " (" + element.workstatus_ST + ")";
                else element["stswfh"] = element.workstatus;

                element["sts"] = strsts + " | " + element["stswfh"];
              }

              tmpData.push();
            });
          }

          tmpData = data;
          const unique = [...new Set(tmpData.map((item) => item.UserNIK), tmpData.map((item) => item.fullname))];
          var unique2 = [];

          if (unique.length > 0) {
            unique.forEach((elnik) => {
              var cnt = 0;
              tmpData.forEach((elData) => {
                if (elData.UserNIK === elnik && cnt == 0) {
                  unique2.push({ UserNIK: elData.UserNIK, fullname: elData.fullname });
                  cnt++;
                }
              });
            });
          }

          var newData = [];
          if (unique2.length > 0) {
            unique2.forEach((elnik) => {
              var map = new Map();
              map.set("UserNIK", elnik.UserNIK);
              map.set("fullname", elnik.fullname);
              var items = tmpData.filter((i) => i.UserNIK === elnik.UserNIK);
              var ldate = vm.listofDate;

              ldate.forEach((eltgl) => {
                map.set(eltgl, "X");
                items.forEach((elItem) => {
                  if (eltgl === elItem.tgl) map.set(elItem.tgl, elItem.sts);
                });
              });

              const obj = Object.fromEntries(map);
              newData.push(obj);
            });
          }

          vm.listAbsensAll = newData;
          vm.isLoading = false;

          var newDataDW = [];
          if (unique2.length > 0) {
            unique2.forEach((elnik) => {
              var map = new Map();
              map.set("UserNIK", elnik.UserNIK);
              map.set("fullname", elnik.fullname);
              var items = tmpData.filter((i) => i.UserNIK === elnik.UserNIK);
              var ldate = vm.listofDate;

              ldate.forEach((eltgl) => {
                map.set(eltgl, "X");
                items.forEach((elItem) => {
                  if (eltgl === elItem.tgl) map.set(elItem.tgl, elItem.stsdw);
                });
              });

              const obj = Object.fromEntries(map);
              newDataDW.push(obj);
            });
          }

          vm.listAbsensAllFileDW = newDataDW;
        })
        .catch((err) => {
          console.log(err);
          vm.isLoading = false;
        });
    },

    feedingReportWaktuTable() {
      const vm = this;
      var month = moment(vm.selectedMonth).format("YYYY-MM");
      var smonth = moment(vm.selectedMonth).format("MMM YYYY");
      vm.excelTitle = "DATA JAM ABSENSI SIPEG " + smonth;
      vm.prepareReports();

      vm.listAbsensAllFileDW2 = [];
      vm.listAbsensAll2 = [];
      vm.isLoading = true;

      getListByMonthAllPegawai(month)
        .then((response) => {
          var data = response.data;
          var tmpData = [];

          if (data.length > 0) {
            data.forEach((element) => {
              element["sts"] = "H";
              if (moment(element.dateIN).isValid()) {
                element["tgl"] = moment(element.dateIN).format("YYYY-MM-DD");
                element["hdateIN"] = moment(element.dateIN).format("HH:mm:ss");
              } else {
                element["sts"] = !moment().isSame(element.dateIN, "day") ? "Xm" : "-";
                element["hdateIN"] = element["sts"];
              }

              if (moment(element.dateOUT).isValid()) {
                element["tgl"] = moment(element.dateOUT).format("YYYY-MM-DD");
                element["hdateOUT"] = moment(element.dateOUT).format("HH:mm:ss");
              } else {
                element["sts"] = !moment().isSame(element.dateIN, "day") ? "Xp" : "-";
                element["hdateOUT"] = element["sts"];
              }

              if (element["sts"] === "Xm") {
                var obj = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj) {
                  obj.forEach((el) => {
                    if (moment(el.dateIN).isValid()) {
                      element["hdateIN"] = moment(el.dateIN).format("HH:mm:ss");
                      element["sts"] = "Xp";
                    }
                  });
                }
              }
              if (element["sts"] === "Xp") {
                var obj2 = data.filter((x) => x.tgl === element["tgl"] && x.fullname === element["fullname"]);
                if (obj2) {
                  obj2.forEach((el) => {
                    if (moment(el.dateOUT).isValid()) {
                      element["hdateOUT"] = moment(el.dateOUT).format("HH:mm:ss");
                      element["sts"] = "H";
                    }
                  });
                }
              }

              element["sts"] = element["hdateIN"] + " | " + element["hdateOUT"];
              tmpData.push();
            });
          }

          tmpData = data;
          const unique = [...new Set(tmpData.map((item) => item.UserNIK), tmpData.map((item) => item.fullname))];
          var unique2 = [];

          if (unique.length > 0) {
            unique.forEach((elnik) => {
              var cnt = 0;
              tmpData.forEach((elData) => {
                if (elData.UserNIK === elnik && cnt == 0) {
                  unique2.push({ UserNIK: elData.UserNIK, fullname: elData.fullname });
                  cnt++;
                }
              });
            });
          }

          var newData = [];
          if (unique2.length > 0) {
            unique2.forEach((elnik) => {
              var map = new Map();
              map.set("UserNIK", elnik.UserNIK);
              map.set("fullname", elnik.fullname);
              var items = tmpData.filter((i) => i.UserNIK === elnik.UserNIK);
              var ldate = vm.listofDate;

              ldate.forEach((eltgl) => {
                map.set(eltgl, "X");
                items.forEach((elItem) => {
                  if (eltgl === elItem.tgl) map.set(elItem.tgl, elItem.sts);
                });
              });

              const obj = Object.fromEntries(map);
              newData.push(obj);
            });
          }

          vm.listAbsensAll2 = newData;
          vm.isLoading = false;

          var newDataDW = [];
          if (unique2.length > 0) {
            unique2.forEach((elnik) => {
              var map = new Map();
              map.set("UserNIK", elnik.UserNIK);
              map.set("fullname", elnik.fullname);
              var items = tmpData.filter((i) => i.UserNIK === elnik.UserNIK);
              var ldate = vm.listofDate;

              ldate.forEach((eltgl) => {
                map.set(eltgl, "X");
                items.forEach((elItem) => {
                  if (eltgl === elItem.tgl) map.set(elItem.tgl, elItem.sts);
                });
              });

              const obj = Object.fromEntries(map);
              newDataDW.push(obj);
            });
          }

          vm.listAbsensAllFileDW2 = newDataDW;
        })
        .catch((err) => {
          console.log(err);
          vm.isLoading = false;
        });
    },
  },
};
</script>

<style>
/* ===== Background Sama dengan Login ===== */
.dash-page {
  position: relative;
  min-height: calc(100vh - 64px);
  overflow: hidden;
}

.dash-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.dash-gradient {
  position: absolute;
  inset: 0;
  background: radial-gradient(1000px 650px at 15% 20%, rgba(245, 131, 43, 0.15), transparent 60%),
    radial-gradient(900px 650px at 85% 10%, rgba(31, 86, 48, 0.3), transparent 60%),
    linear-gradient(135deg, #1f5630 0%, #352f36 100%);
}

.dash-pattern {
  position: absolute;
  inset: 0;
  background-image: url("~@/assets/bpdp-icon-pack.svg");
  background-repeat: repeat;
  background-size: 200px;
  opacity: 0.06;
  filter: grayscale(100%);
  mix-blend-mode: overlay;
}

#dashboard > * {
  position: relative;
  z-index: 1;
}

/* ===== Shell / Card ===== */
.content-card {
  border-radius: 20px !important;
  background: #ffffff !important;
}

.bpdp-card-in {
  border-left: 6px solid rgba(31, 86, 48, 0.95) !important;
}

.bpdp-card-out {
  border-left: 6px solid rgba(245, 131, 43, 0.95) !important;
}

.bpdp-card-head {
  padding: 16px 16px 12px 16px;
  color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.bpdp-in-head {
  background: linear-gradient(90deg, rgba(31, 86, 48, 0.98), rgba(245, 131, 43, 0.75));
}

.bpdp-out-head {
  background: linear-gradient(90deg, rgba(245, 131, 43, 0.92), rgba(53, 47, 54, 0.9));
}

.bpdp-card-title {
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
}

.bpdp-card-subtitle {
  margin-top: 6px;
  opacity: 0.9;
  font-size: 13px;
  font-weight: 500;
}

.bpdp-time {
  font-size: 18px;
  font-weight: 800;
  color: #352f36;
}

/* ===== Button Senada ===== */
.btn-primary {
  background: #f5832b !important;
  color: #ffffff !important;
  box-shadow: 0 10px 22px rgba(245, 131, 43, 0.35);
  text-transform: none !important;
  font-weight: 700 !important;
}

.btn-secondary {
  background: transparent !important;
  border: 2px solid #1F5630 !important;   /* Green BPDP */
  color: #1F5630 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.btn-secondary:hover {
  background: rgba(31,86,48,0.08) !important;
}

.bpdp-disabled {
  opacity: 0.9 !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

/* ===== Table ===== */
.bpdp-table {
  border-radius: 16px !important;
  overflow: hidden !important;
}

/* Style untuk teks radius merah */
.radius-text {
  color: red;
  font-weight: bold;
}
</style>
<!-- eslint-enable -->